<template>
  <div class="container">

    <form @submit.prevent="validateLocalUserData" novalidate>
      <heading-one class="-margin-md">ログインID設定</heading-one>

      <errors-alert :errors="errors" column-only="true" :items="inputItemsCe"></errors-alert>

      <wizard-group class="-margin-md">
        <main-wizard :active-index="1" type="localid"></main-wizard>
      </wizard-group>

      <p>お客さま情報をご登録させていただきます。以下の項目をご入力のうえ「確認画面へ」を押してください。</p>

      <div class="_mb-10">
        <small>※必須の項目は必ずご入力ください。</small>
      </div>

      <section>
        <table-group>
          <table-box>
            <table-body>
              <table-row>
                <table-header badge="必須" badge-size="-sm" class="-entry">電話番号<small class="moji">【半角数字※ハイフン不要】</small></table-header>
                <table-data :hasError="errors['phone']">
                  <input-group :errors="errors" :propNames="['phone']">
                    <inputgroup-append>
                      <input-phone :phone="{phone1: localUserData.phone_1, phone2: localUserData.phone_2, phone3: localUserData.phone_3}" id="phone" @input="setPhone"></input-phone>
                    </inputgroup-append>
                    <input-label id="lastname_kanji">
                      入力例： 09012345678
                    </input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header badge="必須" badge-size="-sm" class="-entry">電話番号<small>（確認用）<small class="moji">【半角数字※ハイフン不要】</small></small></table-header>
                <table-data :hasError="errors['phone_confirmation']">
                  <input-group :errors="errors" :propNames="['phone_confirmation']">
                    <inputgroup-append>
                      <input-phone :phone="{phone1: localUserData.phone_1_confirmation, phone2: localUserData.phone_2_confirmation, phone3: localUserData.phone_3_confirmation}" id="phone_confirmation"  @input="setPhoneConfirmation"></input-phone>
                    </inputgroup-append>
                    <input-label id="lastname_kanji">
                      入力例： 09012345678
                    </input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header badge="必須" badge-size="-sm" class="-entry">メールアドレス<small class="moji">【半角英数】</small></table-header>
                <table-data :hasError="errors['local_mail']">
                  <input-group :errors="errors" :propNames="['local_mail']">
                    <input-label id="">
                      メールアドレスは、ログインIDとして使用します。
                    </input-label>
                    <inputgroup-append>
                      <input-item v-model="localUserData.local_mail" class="-md" id="local_mail" :maxlength="50"></input-item>
                    </inputgroup-append>
                    <input-label id="">
                      入力例:****@au.com
                    </input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header badge="必須" badge-size="-sm" class="-entry">メールアドレス<small>（確認用）<small class="moji">【半角英数】</small></small></table-header>
                <table-data :hasError="errors['local_mail_confirmation']">
                  <input-group :errors="errors" :propNames="['local_mail_confirmation']">
                    <inputgroup-append>
                      <input-item v-model="localUserData.local_mail_confirmation" class="-md" id="local_mail_confirmation" :maxlength="50"></input-item>
                    </inputgroup-append>
                    <input-label id="">
                      入力例:****@au.com
                    </input-label>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header badge="必須" badge-size="-sm" class="-entry">ログインパスワード<small class="moji">【半角英数8文字以上】</small></table-header>
                <table-data :hasError="errors['local_passwd']">
                  <input-group :errors="errors" :propNames="['local_passwd']">
                    <inputgroup-append>
                      <input-item v-model="localUserData.local_passwd" class="-sm" id="local_passwd" type="password" :maxlength="25"></input-item>
                    </inputgroup-append>
                  </input-group>
                </table-data>
              </table-row>
              <table-row>
                <table-header badge="必須" badge-size="-sm" class="-entry">ログインパスワード<small>（確認用）<small class="moji">【半角英数8文字以上】</small></small></table-header>
                <table-data :hasError="errors['local_passwd_confirmation']">
                  <input-group :errors="errors" :propNames="['local_passwd_confirmation']">
                    <inputgroup-append>
                      <input-item v-model="localUserData.local_passwd_confirmation" class="-sm" id="local_passwd_confirmation" type="password" :maxlength="25"></input-item>
                    </inputgroup-append>
                  </input-group>
                </table-data>
              </table-row>
            </table-body>
          </table-box>
        </table-group>
      </section>

      <btngroup-single class="-margin-lg">
        <btn-main @click.prevent="validateLocalUserData" class="-main">
          確認画面へ
        </btn-main>
      </btngroup-single>
    </form>

  </div>
</template>

<script>
import { initCredentials } from '../utils/Auth'
import { localIdUserDataValidate } from '../utils/LocalLoginHelper'
import { inputItemsCe } from '../constants/constant'

import HeadingOne from '../components/heading/HeadingOne'
import MainWizard from '../components/wizard/MainWizard'
import WizardGroup from '../components/wizard/WizardGroup'
import TableGroup from '../components/tables/TableGroup'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import InputGroup from '../components/input/InputGroup'
import InputItem from '../components/input/InputItem'
import InputgroupAppend from '../components/input/InputgroupAppend'
import InputLabel from '../components/input/InputLabel'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import InputPhone from '../components/input/InputPhone'
import ErrorsAlert from '../components/alert/ErrorsAlert'

export default {
  components: {
    ErrorsAlert,
    ListItem,
    InputPhone,
    ListGroup,
    BtnMain,
    BtngroupSingle,
    InputLabel,
    InputgroupAppend,
    InputItem,
    InputGroup,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    WizardGroup,
    MainWizard,
    HeadingOne
  },
  name: 'Ce-006',
  metaInfo: {
    title: 'ログインID設定',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローカルID,認証方法'}
    ]
  },
  data () {
    return {
      errors: {},
      isDisabled: false,
      localUserData: {
        phone_1: '',
        phone_1_confirmation: '',
        phone_2: '',
        phone_2_confirmation: '',
        phone_3: '',
        phone_3_confirmation: '',
        local_mail: '',
        local_mail_confirmation: '',
        local_passwd: '',
        local_passwd_confirmation: ''
      },
      inputItemsCe: inputItemsCe
    }
  },
  mounted () {
    if (localStorage.getItem('local_login_data')) {
      this.localUserData = JSON.parse(localStorage.getItem('local_login_data'))
    }
  },
  methods: {
    validateLocalUserData () {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        initCredentials().then(res => {
          localIdUserDataValidate(this.localUserData).then(res => {
            if (res.result.check === 'OK') {
              localStorage.setItem('local_login_data', JSON.stringify(this.localUserData))
              this.$router.push({name: 'ce004'})
            } else {
              // TODO エラー確認
              this.errors = res.result.error || {}
              this.scrollTop()
              this.isDisabled = false
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    setPhone (data) {
      this.localUserData.phone_1 = data.phone1
      this.localUserData.phone_2 = data.phone2
      this.localUserData.phone_3 = data.phone3
    },
    setPhoneConfirmation (data) {
      this.localUserData.phone_1_confirmation = data.phone1
      this.localUserData.phone_2_confirmation = data.phone2
      this.localUserData.phone_3_confirmation = data.phone3
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Ce006.vue